import React from 'react';

const UserIcon = ({ className }) => (
    <svg className={className} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="20" cy="20" r="20" fill="#220EC9" />
        <circle cx="20" cy="16" r="6" fill="#FCFCFC" />
        <path d="M10 32C10 26 14 22 20 22C26 22 30 26 30 32" stroke="#FCFCFC" strokeWidth="2" strokeLinecap="round" />
    </svg>
);

export default UserIcon;
